export default __webpack_public_path__ + "static/4-fd55075af28b340bce1ba9cf7f652bfd.woff2";